import React, { useContext, useEffect } from 'react';
import { CommonContext } from '../../../../context';
import CourierTable from './CourierTable';

const Courier = () => {
    const { onMerchantCourier, rowData } = useContext(CommonContext)
    useEffect(() => {
        if (rowData?.id) {
            onMerchantCourier(rowData?.id, rowData?.service_type);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <>
            <CourierTable />
        </>
    );
};

export default Courier;
